module.exports = __webpack_public_path__ + "media/images/file-icons/256/002-tool-5408d1a38edbf7c8fdacbe331a579987.png";